export default function Unauthorize() {
  return <div>401</div>;
}
